<template>
  <v-card
    class="fill-height"
    fluid
    flat
    :data-testid="getTestId('main-map-card')"
  >
    <div
      justify="start"
      align="stretch"
      :style="{ width: '100%', height: '100%' }"
      :data-testid="getTestId('main-map-container')"
    >
      <v-card outlined :style="{ width: '100%', height: '100%' }" :data-testid="getTestId('main-map-card-inner')">
        <DotSolarMapBox
          :report-id="getReportId"
          :map-size="{ width: '100%', height: '100%' }"
          :map-editable="
            userProfile && userProfile.userRole === 'ADMIN' ? true : false
          "
          :data-testid="getTestId('dot-solar-map-box')"
        />
      </v-card>
    </div>
  </v-card>
</template>

<script>
import 'ol/ol.css';
import { mapGetters } from 'vuex';
import { getTestId } from '@/utils/testUtils';
import { appPerfLazyChunk, appPerfMark, appPerfSinceMyProfile } from '@/utils/appBootstrapPerfLog.js';

export default {
  components: {
    DotSolarMapBox: appPerfLazyChunk('MainMapCard.DotSolarMapBox', () => import('../map/DotSolarMapBox'))
  },
  data: () => ({
    mousePressed: false,
    map: undefined,
    map3d: undefined,
    layers: [],
    layer: {
      solorImages: undefined,
      solorTiles: undefined,
      solorFeatures: undefined,

      panelFeature: undefined,

      photoImage: undefined,
      photoFeature: undefined,

      rgbImage: undefined,
      rgbFeature: undefined,

      thumalImage: undefined,
      thumalFeature: undefined
    },

    images: [], // all images
    image: undefined, //selected image
    features: [], //all features
    featuresTree: {},

    rgbImageOnMap: false,

    panels: [], // all tree
    panel: [{ id: 'root', name: 'ALL Panels', children: [] }], //current tree

    selectedPanels: [],
    selectedFeatures: [],
    center: [126.6446031774295, 36.539451104924396], //태양광
    zoom: 19.09898572944446,
    projection: 'EPSG:4326',

    coordinate: {
      camera: {
        center: undefined,
        distance: undefined,
        heading: undefined,
        tilt: undefined,
        position: undefined,
        altitude: undefined
      },
      view: {
        center: undefined,
        rotation: undefined,
        zoom: undefined
      },
      pointer: undefined
    }
  }),
  computed: {
    ...mapGetters({ userProfile: 'user/getUserProfile' }),
    ...mapGetters({ getReportId: 'explorer/getReportId' })
  },

  methods: {
    initMap() {},
    getTestId(testId) {
      return getTestId(testId);
    }
  },
  mounted() {
    appPerfMark('MainMapCard:mounted');
    appPerfSinceMyProfile('MainMapCard:mounted', { reportId: this.getReportId });
  }
};
</script>

<style></style>
